import http from '@/utils/http';

export function queryList({ certNo, name, corpCode }) {
  return http({
    url: '/extapi/service/exceptionBatchRefund.htm',
    method: 'POST',
    params: {
      msg: JSON.stringify({
        certNo: certNo,
        corpCode: corpCode,
        method: 'queryList',
        name: name
      })
    }
  });
}

export function queryListDone({ certNo, name, corpCode, page = 1 }) {
  return http({
    url: '/extapi/service/exceptionBatchRefund.htm',
    method: 'POST',
    params: {
      msg: JSON.stringify({
        certNo,
        corpCode,
        index: page,
        method: 'exceptionRefundList',
        pageSize: 50,
        returnState: '0'
      })
    }
  });
}

export function getBankList() {
  return http({
    url:
      'http://paycenter.zhiyoubao.com/manage/api/admin/account/getBankDicNotForbidden',
    method: 'GET'
  });
}

export function refund(orderData, formPayload, corpCode) {
  return http({
    url: '/extapi/service/exceptionBatchRefund.htm',
    method: 'POST',
    params: {
      msg: JSON.stringify({
        ...orderData,
        ...{
          accName: formPayload.name,
          cardNo: formPayload.code,
          corpCode,
          method: 'exceptionRefund',
          moneyMode: 1,
          billFid: orderData.fid,
          paysum: orderData.sellPrice * orderData.ticketCount
        }
      })
    }
  });
}
